import Vue from 'vue'
import login from '@/views/login.vue'

let loginConstructor  = Vue.extend(login)

const mylogin = (props) => {
  const instance = new loginConstructor({
    propsData: props
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  return instance
}

export default mylogin